window.arTransactionsCreditsCellStyle = function(value, row) {
    if (!value) {
        return false;
    }
    return {
        classes: row.credits_cell_style
    };
};
